/*
    # 메뉴 데이터 형식
        {
            comCode: String,      //회사코드
            proCode: String,      //공장코드
            sysType: String,      //시스템구분
            menuCode: String,     //메뉴코드
            moduleCode: String,   //모듈코드
            menuName: String,     //매뉴명
            paCode: String,       //부모메뉴코드
            pgCode: String,       //프로그램코드
            sortFlag: String,     //정렬순서
        }
*/

const menuState = {
  menus: [
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "11",
      moduleCode: "11",
      menuName: "baseInfo",
      paCode: null,
      pgCode: null,
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1111",
      moduleCode: "11",
      menuName: "codeInfo",
      paCode: "11",
      pgCode: null,
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0010",
      moduleCode: "11",
      menuName: "commonCode",
      paCode: "1111",
      pgCode: "bas0010",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0020",
      moduleCode: "11",
      menuName: "baseInfoExcel",
      paCode: "1111",
      pgCode: "bas0020",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1112",
      moduleCode: "11",
      menuName: "companyBaseInfo",
      paCode: "11",
      pgCode: null,
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0110",
      moduleCode: "11",
      menuName: "companyInfo",
      paCode: "1112",
      pgCode: "bas0110",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0120",
      moduleCode: "11",
      menuName: "factoryInfo",
      paCode: "1112",
      pgCode: "bas0120",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0130",
      moduleCode: "11",
      menuName: "factoryCalendar",
      paCode: "1112",
      pgCode: "bas0130",
      sortFlag: "3",
      userFlag: "Y"
    },

    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1113",
      moduleCode: "11",
      menuName: "productionStandardInformation",
      paCode: "11",
      pgCode: null,
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0210",
      moduleCode: "11",
      menuName: "itemInformation",
      paCode: "1113",
      pgCode: "bas0210",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0220",
      moduleCode: "11",
      menuName: "bomJeonggae",
      paCode: "1113",
      pgCode: "bas0220",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0230",
      moduleCode: "11",
      menuName: "bomReversal",
      paCode: "1113",
      pgCode: "bas0230",
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0240",
      moduleCode: "11",
      menuName: "jobSetupManagement",
      paCode: "1113",
      pgCode: "bas0240",
      sortFlag: "4",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0250",
      moduleCode: "11",
      menuName: "managementOfWorkStandards",
      paCode: "1113",
      pgCode: "bas0250",
      sortFlag: "5",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0260",
      moduleCode: "11",
      menuName: "jobSetupStandardManagement",
      paCode: "1113",
      pgCode: "bas0260",
      sortFlag: "6",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1114",
      moduleCode: "11",
      menuName: "logisticsStandardInformation",
      paCode: "11",
      pgCode: null,
      sortFlag: "4",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0310",
      moduleCode: "11",
      menuName: "itemByCustomer",
      paCode: "1114",
      pgCode: "bas0310",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0320",
      moduleCode: "11",
      menuName: "exchangeRateInformationManagement",
      paCode: "1114",
      pgCode: "bas0320",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1115",
      moduleCode: "11",
      menuName: "qualityStandardInformation",
      paCode: "11",
      pgCode: null,
      sortFlag: "5",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0410",
      moduleCode: "11",
      menuName: "classificationOfInspectionItems",
      paCode: "1115",
      pgCode: "bas0410",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0420",
      moduleCode: "11",
      menuName: "qualityStandardMasterManagement",
      paCode: "1115",
      pgCode: "bas0420",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "bas0430",
      moduleCode: "11",
      menuName: "inspectionStandardManagement",
      paCode: "1115",
      pgCode: "bas0430",
      sortFlag: "3",
      userFlag: "Y"
    },

    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "12",
      moduleCode: "12",
      menuName: "salesManage",
      paCode: null,
      pgCode: null,
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1211",
      moduleCode: "12",
      menuName: "orderManage",
      paCode: "1211",
      pgCode: null,
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0010",
      moduleCode: "12",
      menuName: "orderIntake",
      paCode: "1211",
      pgCode: "sal0010",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0020",
      moduleCode: "12",
      menuName: "orderIntakeUpload",
      paCode: "1211",
      pgCode: "sal0020",
      sortFlag: "2",
      userFlag: "Y"
    },

    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1212",
      moduleCode: "12",
      menuName: "shipmentManagement",
      paCode: "12",
      pgCode: null,
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0110",
      moduleCode: "12",
      menuName: "shippingPlanRegistration",
      paCode: "1212",
      pgCode: "sal0110",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0120",
      moduleCode: "12",
      menuName: "shippingRegistration",
      paCode: "1212",
      pgCode: "sal0120",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0130",
      moduleCode: "12",
      menuName: "shipmentInspection",
      paCode: "1212",
      pgCode: "sal0130",
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0140",
      moduleCode: "12",
      menuName: "returnRegistration",
      paCode: "1212",
      pgCode: "sal0140",
      sortFlag: "4",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0150",
      moduleCode: "12",
      menuName: "salesConfirmation",
      paCode: "1212",
      pgCode: "sal0150",
      sortFlag: "5",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1213",
      moduleCode: "12",
      menuName: "statusManagement",
      paCode: "12",
      pgCode: null,
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0210",
      moduleCode: "12",
      menuName: "orderProgressStatus",
      paCode: "1213",
      pgCode: "sal0210",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0220",
      moduleCode: "12",
      menuName: "shipmentStatusByPeriod",
      paCode: "1213",
      pgCode: "sal0220",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sal0230",
      moduleCode: "12",
      menuName: "shipmentReturnStatus",
      paCode: "1213",
      pgCode: "sal0230",
      sortFlag: "3",
      userFlag: "Y"
    },

    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "13",
      moduleCode: "13",
      menuName: "productionManagement",
      paCode: null,
      pgCode: null,
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1311",
      moduleCode: "13",
      menuName: "planManagement",
      paCode: "13",
      pgCode: null,
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0010",
      moduleCode: "13",
      menuName: "productionPlanManagement",
      paCode: "1311",
      pgCode: "pro0010",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0020",
      moduleCode: "13",
      menuName: "productionPlanRegistration",
      paCode: "1311",
      pgCode: "pro0020",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0030",
      moduleCode: "13",
      menuName: "plantationStatusByOrder",
      paCode: "1311",
      pgCode: "pro0030",
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0040",
      moduleCode: "13",
      menuName: "currentStatusOfFarmlandStandardMaterials",
      paCode: "1311",
      pgCode: "pro0040",
      sortFlag: "4",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0050",
      moduleCode: "13",
      menuName: "workOrderManagement",
      paCode: "1311",
      pgCode: "pro0050",
      sortFlag: "5",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0060",
      moduleCode: "13",
      menuName: "materialReleaseRequestRegistration",
      paCode: "1311",
      pgCode: "pro0060",
      sortFlag: "6",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0070",
      moduleCode: "13",
      menuName: "facilityOperation",
      paCode: "1311",
      pgCode: "pro0070",
      sortFlag: "7",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "1312",
      moduleCode: "13",
      menuName: "statusManagement",
      paCode: "13",
      pgCode: null,
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0110",
      moduleCode: "13",
      menuName: "workOrderProgressStatus",
      paCode: "1312",
      pgCode: "pro0110",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0120",
      moduleCode: "13",
      menuName: "productionPerformanceStatus",
      paCode: "1312",
      pgCode: "pro0120",
      sortFlag: "2",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0130",
      moduleCode: "13",
      menuName: "processDefectStatus",
      paCode: "1312",
      pgCode: "pro0130",
      sortFlag: "3",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0140",
      moduleCode: "13",
      menuName: "nonOperationStatus",
      paCode: "1312",
      pgCode: "pro0140",
      sortFlag: "4",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0160",
      moduleCode: "13",
      menuName: "performanceStatusByProcess",
      paCode: "1312",
      pgCode: "pro0160",
      sortFlag: "5",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0170",
      moduleCode: "13",
      menuName: "inventoryStatusBasedOnBOM",
      paCode: "1312",
      pgCode: "pro0170",
      sortFlag: "6",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "pro0180",
      moduleCode: "13",
      menuName: "jobReport",
      paCode: "1312",
      pgCode: "pro0180",
      sortFlag: "7",
      userFlag: "Y"
    },

    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "20",
      moduleCode: "20",
      menuName: "systemManage",
      paCode: null,
      pgCode: null,
      sortFlag: "9",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "2011",
      moduleCode: "20",
      menuName: "menuManage",
      paCode: "20",
      pgCode: null,
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sys0010",
      moduleCode: "20",
      menuName: "menuManage",
      paCode: "2011",
      pgCode: "sys0010",
      sortFlag: "1",
      userFlag: "Y"
    },
    {
      comCode: "COM0001",
      proCode: "PRO0001",
      sysType: "MES",
      menuCode: "sys0020",
      moduleCode: "20",
      menuName: "groupMenuManage",
      paCode: "2011",
      pgCode: "sys0020",
      sortFlag: "2",
      userFlag: "Y"
    },    
  ]
}
  
export default menuState